import React from 'react';
import { useParams } from 'react-router-dom';

import BackButton from '@ts-core/components/BackButton';
import StudentPracticeSessionResult from '@ts-core/modules/practice/components/StudentPracticeSessionResult';

import { useStudentPracticeSession } from 'modules/practice/hooks';
import { useStudent } from 'modules/students/hooks';

const StudentCoursePracticeSessionResultsPage = () => {
  const { courseId, studentId, practiceSessionId } = useParams<{ courseId: string; studentId: string; practiceSessionId: string }>();

  const { studentPracticeSession, loading } = useStudentPracticeSession({
    courseId,
    studentId,
    practiceSessionId,
  });
  const { student } = useStudent({ courseId, studentId });

  return (
    <>
      <BackButton title="Sesión de Práctica" subtitle={student?.name} href={`/${courseId}/students/${studentId}/practice`} />
      <StudentPracticeSessionResult practiceSession={studentPracticeSession} loading={loading} />
    </>
  );
};

export default StudentCoursePracticeSessionResultsPage;
